<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div v-if="createModel == 1">
			<div class="mb-2 mt-2 pt-3">
				
				<template >
					<el-header style="display: inline-block;">{{ editIndex > -1 ? '修改比賽' : '添加比賽' }}</el-header>
				</template>
				<div style="float: right;">
					<el-button @click="resetForm">返 回</el-button>
				</div>
			</div>
			<!-- <div class="" slot="footer" style="text-align: center; padding: 10px 0px 30px;"></div> -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'130px'">

			<el-form-item  label="比賽圖標" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'8',cms_type:'2'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccessLogo"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.logo" :src="form.logo" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span style="color: red;">圖片比例為 1*1 的正方形</span>
				</el-form-item>


			<el-form-item label="比賽名稱" prop="title">
				<!-- <el-input v-model="form.title" placeholder="比賽名稱" clearable size="small" style="width: 85%;"></el-input> -->
				<el-input 
					size="small" 
					v-model="form.title" 
					placeholder="比賽名稱" 
					 style="width: 85%;"
					>
				</el-input>
			</el-form-item>

			<el-form-item label="比賽副標題1" prop="title_vice">
				<el-input v-model="form.title_vice" placeholder="比賽副標題1" clearable size="small" maxlength="25" show-word-limit   style="width: 85%;"></el-input>
			</el-form-item>
			<el-form-item label="比賽副標題2" prop="title_vices">
				<el-input v-model="form.title_vices" placeholder="比賽副標題2" clearable size="small" maxlength="25" show-word-limit   style="width: 85%;"></el-input>
			</el-form-item>

			<el-form-item label="比賽副標題2圖片1" prop="title_vice_img1">
				<el-upload
					name="file"
					class="avatar-uploader"
					action="/admin/image/uploadNew"
					:headers="{token:$store.state.user.token}"
					:data="{type:'8',cms_type:'2'}"
					:show-file-list="false"
					:on-success="handleAvatarSuccessTitleViceImg1"
					:before-upload="beforeAvatarUpload">
					<img v-if="form.title_vice_img1_logo" :src="form.title_vice_img1_logo" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<span style="color: red;">圖片比例為 1*1 的正方形</span>
			</el-form-item>

			<el-form-item label="比賽副標題2圖片2" prop="title_vice_img2">
				<el-upload
					name="file"
					class="avatar-uploader"
					action="/admin/image/uploadNew"
					:headers="{token:$store.state.user.token}"
					:data="{type:'8',cms_type:'2'}"
					:show-file-list="false"
					:on-success="handleAvatarSuccessTitleViceImg2"
					:before-upload="beforeAvatarUpload">
					<img v-if="form.title_vice_img2_logo" :src="form.title_vice_img2_logo" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<span style="color: red;">圖片比例為 1*1 的正方形</span>
			</el-form-item>

				<el-form-item  label="比賽簡介" prop="content">
					<quill-editor ref="text" v-model="form.content" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
				</el-form-item>

				
				<el-form-item  label="獎項備註" prop="prize_info">
								<el-input type="textarea" :rows="2" v-model="form.prize_info" 
								placeholder="獎項備註" 
								maxlength="50"
								show-word-limit  
								clearable size="small" style="width: 85%;"></el-input>
							</el-form-item>

				<el-form-item label="學科類型"   prop="subject_id">
								<el-select @change="changeType" v-model="form.subject_id">
									<el-option
									v-for="item in subject_list"
									:key="item.id"
									:label="item.name"
									:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

								<el-form-item  label="是否免費"  prop="pay_type">
									<el-radio-group v-model="form.pay_type" :disabled="form.is_notapply == 1">
										<el-radio :label="1">免費</el-radio>
										<el-radio :label="2">付費</el-radio>
									</el-radio-group>
								</el-form-item>

								<el-form-item label="是否不需要報名"  prop="is_notapply">
									<el-radio-group v-model="form.is_notapply">
										<el-radio :label="0">否</el-radio>
										<el-radio :label="1">是</el-radio>
									</el-radio-group>
								</el-form-item>

								<el-form-item label="是否展示缺席"  prop="is_absent_show" v-show="form.is_notapply == 1">
									<el-radio-group v-model="form.is_absent_show">
										<el-radio :label="0">否</el-radio>
										<el-radio :label="1">是</el-radio>
									</el-radio-group>
								</el-form-item>

								<el-form-item label="顯示倒計時" prop="is_show_time">
									<el-switch
										v-model="form.is_show_time"
										:active-value="1"
										:inactive-value="0"
										active-text="顯示"
										inactive-text="隱藏">
									</el-switch>
								</el-form-item>

								
								<el-form-item label="付費金額" prop="money"	v-show="form.pay_type==2">
									<el-input v-model="form.money" placeholder="付費金額" clearable size="small" style="width: 65%;"></el-input>
									<span class="text-info" style="margin-left: 20px;">學校用戶</span>
								</el-form-item>

								<el-form-item label="付費金額" prop="no_school_money"	v-show="form.pay_type==2">
									<el-input v-model="form.no_school_money" placeholder="付費金額" clearable size="small" style="width: 65%;"></el-input>
									<span class="text-success" style="margin-left: 20px;">非學校用戶</span>
								</el-form-item>

								<el-form-item label="參加用戶類型">
									<el-radio-group v-model="form.is_school">
										<el-radio :label="0">全部</el-radio>
										<!-- 自定義框 -->
										<div class="custom-box">
										<el-radio :label="1">非學校用戶</el-radio>
										<el-radio :label="2">全部學校</el-radio>
										<el-radio :label="3">指定學校</el-radio>
										<el-radio :label="4">用戶標籤</el-radio>
										</div>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="用戶標籤" prop="user_label_ids" v-show="form.is_school == 4">
									<el-select v-model="form.user_label_ids" multiple filterable clearable style="width: 85%;" placeholder="請選擇">
										<el-option
											v-for="item in user_label_options"
											:key="item.id"
											:label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								
								<el-form-item label="參加學校" prop="school_id" v-show="form.is_school == 3">
									<el-select v-model="form.school_id" multiple filterable  style="width: 85%;" placeholder="請選擇">
										<el-option
											v-for="item in school_list"
											:key="item.id"
											:label="item.school_no +' - '+ item.add_name + ' - ' + item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="報名日期" prop="time" size="small"  >
									<el-date-picker
										v-model="form.time"
										type="daterange"
										align="right"
										unlink-panels
										value-format="yyyy-MM-dd"
										range-separator="至"
										start-placeholder="開始日期"
										end-placeholder="結束日期"
										@change="updateDateLimits"
										:picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>
							
							<el-form-item label="成績公布日期" prop="result_date"  size="small"  >
								<el-date-picker
								v-model="form.result_date"
								value-format="yyyy-MM-dd HH:mm:ss"
								type="datetime"
								placeholder="選擇日期"
								:picker-options="dateLimits">
								</el-date-picker>
							</el-form-item>
							
							<el-form-item label="訂購獎品截止" prop="end_time"  size="small"  >
										<el-date-picker
										v-model="form.end_time"
										value-format="yyyy-MM-dd"
										type="date"
										placeholder="選擇日期"
										:picker-options="dateLimits">
										</el-date-picker>
							</el-form-item>

							<el-form-item label="公告截止展示" prop="notice_end_time" size="small"  >
								<el-date-picker
									v-model="form.notice_end_time"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="選擇日期"
									:picker-options="dateLimits">
								</el-date-picker>
							</el-form-item>

							<el-form-item label="截止查看成績" prop="check_rank_time" size="small"  >
								<el-date-picker
									v-model="form.check_rank_time"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="選擇日期"
									:picker-options="dateLimits">
								</el-date-picker>
							</el-form-item>
							
							<el-form-item label="優惠碼" prop="discount_code"  size="small"  >
								<el-input v-model="form.discount_code" placeholder="優惠碼" clearable size="small" style="width: 65%;"></el-input>
							</el-form-item>

							<el-form-item label="優惠金額" prop="discount_money"  size="small"  >
								<el-input v-model="form.discount_money" placeholder="優惠金額" type="number" clearable size="small" style="width: 65%;"></el-input>
							</el-form-item>
						
							<!-- <el-form-item label="郵費" prop="postage"  size="small"  >
								<el-input v-model="form.postage" placeholder="郵費" type="number" clearable size="small" style="width: 65%;"></el-input>
							</el-form-item>
						 -->
							<el-form-item label="試卷" prop="paperList">
								<el-button @click="addDomain(false)" style="margin-bottom: 10px;">添加試卷</el-button>
								<el-table :data="form.paperList" border style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="expand" label="題目" align="center" width="60">
									<!-- 使用作用域插槽访问當前行數据 -->
									<template slot-scope="scope">
										<!-- 绑定内嵌表格數据到當前行的topList属性 -->
										<el-table :data="scope.row.topList" border style="width: 100%" @selection-change="handleSelectionChange">
											<el-table-column align="center" prop="title" label="題目"></el-table-column>
											<el-table-column align="center" prop="score" label="分數"></el-table-column>

												<el-table-column align="center"  prop="label_name" label="標籤">
													<template slot-scope="scope">
														<span>
															<el-tag >{{scope.row.label_name}}</el-tag>
														</span>
													</template>
												</el-table-column>
												
												<el-table-column align="center" width="200"  prop="topic_type"  label="類型">
													<template slot-scope="scope">
														<el-tag v-if="scope.row.topic_type==1" type="success">選擇題</el-tag>
														<el-tag v-if="scope.row.topic_type==2" >填空題</el-tag>
														<el-tag v-if="scope.row.topic_type==3">上傳題</el-tag>
													</template>
												</el-table-column>
										</el-table>
									</template>
									</el-table-column>
									<el-table-column align="center" prop="name" label="年級組名稱"></el-table-column>
									<el-table-column align="center" prop="count" label="題目數"></el-table-column>
									<el-table-column align="center" prop="total_score" label="總分"></el-table-column>
									<el-table-column prop="id" align="center" width="140" label="操作">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addDomain(scope)">操作</el-button>
												<el-button @click="delDomain(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
							
							<el-form-item label="名次-獎品" prop="ranking">
								<el-button @click="addRanking(false)" style="margin-bottom: 10px;">添加名次-獎品</el-button>
								<el-table :data="form.ranking" border style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="expand" label="獎品" align="center" width="60">
										<template slot-scope="scope">
											<el-table :data="scope.row.prize" border style="width: 100%" @selection-change="handleSelectionChange">
												<el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
												<el-table-column align="center" prop="money" label="金額"></el-table-column>
												<el-table-column align="center" prop="postage" label="郵費"></el-table-column>
												<el-table-column align="center" prop="content" label="獎品備註"></el-table-column>	
											</el-table>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="level_name" label="名次"></el-table-column>
									<el-table-column align="center" prop="level" label="戰績">
										<template slot-scope="v">
											<el-tag v-if="v.row.level==1" >金</el-tag>
											<el-tag v-if="v.row.level==2" >銀</el-tag>
											<el-tag v-if="v.row.level==3" >銅</el-tag>
											<el-tag v-if="v.row.level==4" >其他</el-tag>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="rank_show" label="榜單排名">
										<template slot-scope="v">
											<el-tag v-if="v.row.rank_show==1" >金</el-tag>
											<el-tag v-if="v.row.rank_show==2" >銀</el-tag>
											<el-tag v-if="v.row.rank_show==3" >銅</el-tag>
											<el-tag v-if="v.row.rank_show==0" >其他</el-tag>
										</template>
									</el-table-column>
									<el-table-column align="center" prop="diamond" label="贈送鑽石"></el-table-column>
									<el-table-column align="center" prop="money" label="贈送金幣"></el-table-column>
									<el-table-column prop="id" align="center" width="140" label="操作">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addRanking(scope)">操作</el-button>
												<el-button @click="delRanking(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>

							<el-form-item  label="獎品購買備註" prop="message">
								<el-input type="textarea" :rows="3" v-model="form.message" 
								placeholder="獎品購買備註" 
								maxlength="1000"
								show-word-limit  
								clearable size="small" style="width: 85%;"></el-input>
							</el-form-item>

					</el-form>
					<div slot="footer"  style="text-align: center;    padding: 40px 0 30px 0;">
						<el-button @click="resetForm">取 消</el-button>
						<el-button v-if="openModelType" :loading="submitLoading" type="primary" @click="submit">確 定</el-button>
					</div>
			<el-dialog :close-on-click-modal="false"  :before-close="handleClose" :title="editPaperIndex > -1 ? '修改試卷' : '添加試卷'" :visible.sync="createPaperModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesPaper" ref="formPaper" :model="formPaper" :label-width="layout.is_phone?'80px':'130px'">
					<el-form-item label="組別名稱" prop="name"><el-input v-model="formPaper.name" placeholder="組別名稱" maxlength="10" show-word-limit clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="年級" prop="grade_id"	>
										<el-select v-model="formPaper.grade_id" style="width: 85%;" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in processedGradeList"
											:key="item.id"
											:label="item.name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
									
							<el-form-item label="比賽時間" size="small" prop="timeArr">
							<el-date-picker
								v-model="formPaper.timeArr"
								type="datetimerange"
								range-separator="至"
								start-placeholder="開始時間"
								end-placeholder="結束時間"
								value-format="yyyy-MM-dd HH:mm:ss"
								@change="handleTimeRangeChange"> <!-- 当比賽時間发生变化时触发 -->
							</el-date-picker>
							</el-form-item>

							<el-form-item label="最遲入場時間" size="small" prop="latest_time">
							<el-date-picker
								v-model="formPaper.latest_time"
								type="datetime"
								placeholder="選擇日期時間"
								value-format="yyyy-MM-dd HH:mm:ss"
								:disabled="!formPaper.timeArr || formPaper.timeArr.length === 0" 
								:picker-options="latestTimePickerOptions"
								@change="validateLatestTime"> <!-- 动态限制可选范围 -->
							</el-date-picker>
							</el-form-item>



					<el-form-item label="做題時長(分)" prop="time" ><el-input v-model="formPaper.time" clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="題目數量" ><el-input v-model="formPaper.count" disabled clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item label="總分" ><el-input v-model="formPaper.total_score" disabled clearable size="small" style="width: 85%;"></el-input></el-form-item>
					<el-form-item >
						<el-button @click="addTag(false)">添加題目</el-button>
						<el-upload
							style="display: inline-flex;margin-left: 20px;"
							action=""
							:before-upload="beforeUpload"
							:show-file-list="false"
							accept=".xlsx,.xls"
						>
							<el-button class="mr-2" type="warning" size="mini">點擊上傳Excel文件</el-button>
						</el-upload>
						<el-button @click="downloadTemplate" class="mr-2" type="success" size="mini">下載題目模版文件</el-button>
						<el-button @click="deleteTagAll" class="mr-2" type="danger" size="mini">清空所有題目</el-button>
					
					</el-form-item>
					<el-form-item label="題目" prop="topList">
						<el-table :data="formPaper.topList" border style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column align="center" type="index" width="50" label="題號">
								<template slot-scope="scope">
									<span>{{scope.$index+1}}</span>	
									<!-- <el-image 
										v-if="scope.row.img"
										style="width: 100px; height: 100px"
										src="" 
										:preview-src-list="[scope.row.img]">
									</el-image> -->
									<i
										v-if="scope.row.img"
										class="el-icon-picture"
										style="cursor: pointer;"
										@click="handlePreview(scope.row)"
										></i>

										<!-- 隐藏的 el-image，用来触发预览 -->
										<el-image
										ref="previewImage"
										style="display: none;"
										:src="previewSrc"
										:preview-src-list="[previewSrc]"
										></el-image>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="title" label="題目"></el-table-column>
							<el-table-column align="center" prop="score" label="分數"></el-table-column>
							<el-table-column align="center" prop="option_a" label="選項a"></el-table-column>
							<el-table-column align="center" prop="option_b" label="選項b"></el-table-column>
							<el-table-column align="center" prop="option_c" label="選項c"></el-table-column>
							<el-table-column align="center" prop="option_d" label="選項d"></el-table-column>
							<el-table-column align="center" prop="answer_o" label="選擇題答案"></el-table-column>
							<el-table-column align="center" prop="answer" label="填空題答案"></el-table-column>
							<el-table-column align="center" prop="difficulty" label="難度"></el-table-column>
							<el-table-column align="center" width="100"  prop="label_name" label="標籤">
								<template slot-scope="v">
									<span>
										<el-tag >{{v.row.label_name}}</el-tag>
									</span>
								</template>
							</el-table-column>
							
							<el-table-column align="center" width="80"  prop="topic_type"  label="類型">
								<template slot-scope="v">
									<el-tag v-if="v.row.topic_type==1" type="success">選擇題</el-tag>
									<el-tag v-if="v.row.topic_type==2" >填空題</el-tag>
									<el-tag v-if="v.row.topic_type==3" >上傳題</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="id" align="center" width="140" label="操作">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="primary" @click="addTag(scope)">操作</el-button>
										<el-button @click="deleteTag(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetPaperForm">取 消</el-button>
					<el-button type="primary" @click="submitPaper">確 定</el-button>
				</div>
			</el-dialog>


			<el-dialog :close-on-click-modal="false"  :before-close="handleClose" :title="editRankingIndex > -1 ? '修改名次-獎品' : '添加名次-獎品'" :visible.sync="createRankingModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesRanking" ref="formRanking" :model="formRanking" :label-width="layout.is_phone?'80px':'100px'">
					<el-form-item   label="名次" prop="level_name">
						<el-input v-model="formRanking.level_name" maxlength="20" :disabled="formRanking.is_default ? true : false" show-word-limit placeholder="名次" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					
					<el-form-item label="鑽石" prop="diamond">
						<el-input type="number" v-model="formRanking.diamond" 
						placeholder="鑽石數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="金幣" prop="money">
						<el-input type="number" v-model="formRanking.money" 
						placeholder="金幣數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="贈送禮物" prop="gift_id"	>
										<el-select @change="changeGift" v-model="formRanking.gift_id" style="width: 85%;" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in user_gift"
											:key="item.id"
											:label="item.type_name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item  label="戰績" >
										<el-radio-group v-model="formRanking.level" >
											<el-radio :label="1">金</el-radio>
											<el-radio :label="2">銀</el-radio>
											<el-radio :label="3">銅</el-radio>
											<el-radio :label="4">其他</el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item  label="榜單排名" >
										<el-radio-group v-model="formRanking.rank_show" >
											<el-radio :label="1">金</el-radio>
											<el-radio :label="2">銀</el-radio>
											<el-radio :label="3">銅</el-radio>
											<el-radio :label="0">其他</el-radio>
										</el-radio-group>
									</el-form-item>

					<el-form-item >
						<el-button @click="addPrize(false)">添加獎品</el-button>
					</el-form-item>
					<el-form-item label="獎品" prop="topList">
						<el-table :data="formRanking.prize" border style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
							<el-table-column align="center" prop="money" label="金額"></el-table-column>
							<el-table-column align="center" prop="postage" label="郵費"></el-table-column>
							<el-table-column align="center" prop="content" label="獎品備註"></el-table-column>
						
							<el-table-column prop="id" align="center" width="140" label="操作">
								<template slot-scope="scope">
									<el-button-group>
										<el-button size="mini" plain type="primary" @click="addPrize(scope)">操作</el-button>
										<el-button @click="delPrize(scope)" v-auth="'delAdmin'" size="mini" plain type="danger">刪除</el-button>
									</el-button-group>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetRankingForm">取 消</el-button>
					<el-button type="primary" @click="submitRanking">確 定</el-button>
				</div>
			</el-dialog>

			<el-dialog :close-on-click-modal="false"  :title="editPrizeIndex==-1?'添加獎品':'修改獎品'" :visible.sync="createPrizeModel" 
			top="5vh" :width="layout.is_phone?'90%':'50%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form ref="formPrize" :rules="rulesPrize" :model="formPrize" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
					<el-form-item label="獎品名稱" prop="name">
						<el-input type="text" v-model="formPrize.name" 
						placeholder="獎品名稱" 
						maxlength="20"  
        				show-word-limit  
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="金額" prop="money">
						<el-input type="number" v-model="formPrize.money" 
						placeholder="金額" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="郵費" prop="postage">
						<el-input type="number" v-model="formPrize.postage" 
						placeholder="郵費" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="獎品簡介" prop="content">
						<el-input type="text" v-model="formPrize.content"
						maxlength="100"  
        				show-word-limit  
						placeholder="獎品簡介" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetPrizeForm">取 消</el-button>
					<el-button type="primary" @click="submitPrize">確 定</el-button>
				</div>
			</el-dialog>

			<el-dialog :close-on-click-modal="false"  :title="editTagIndex==-1?'添加題目':'修改題目'" :visible.sync="createTagModel" 
			top="5vh" :width="layout.is_phone?'90%':'50%'" @opened="scrollToTop">
			<div ref="dialogContent" style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form ref="topForm" :rules="rulesTag" :model="topForm" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
					<el-form-item  label="題目圖片" prop="icon" >
						<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'2'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="topForm.icon" :src="topForm.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<el-form-item label="題目標籤"  prop="label_id">
						<el-select v-model="topForm.label_id" >
							<el-option
								v-for="item in label_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
							<!-- <el-option v-if="label_list.length === 0" disabled value="">暂无可选標籤</el-option> -->
						</el-select>
					</el-form-item>

					<el-form-item  label="題目類型"  prop="topic_type">
						<el-radio-group v-model="topForm.topic_type" >
							<el-radio :label="1">選擇題</el-radio>
							<el-radio :label="2">填空題</el-radio>
							<el-radio :label="3">上傳題</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="分數" prop="score">
						<el-input type="number" v-model="topForm.score" 
						placeholder="題目分數" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="題目" prop="title">
						<el-input type="textarea" :rows="8" v-model="topForm.title" 
						placeholder="題目（中文）" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="題目（英文）" prop="title_en">
						<el-input type="textarea" :rows="8" v-model="topForm.title_en" 
						placeholder="題目（英文）" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>


					<el-form-item label="難度" prop="difficulty">
						<el-rate
							style="line-height: 49px;"
							v-model="topForm.difficulty"
							:colors="colors">
						</el-rate>
					</el-form-item>
		
					<div v-if="topForm.topic_type == 1">
						<el-form-item label="選項A" prop="option_a">
							<div style="display: flex; align-items: center; margin-bottom: 10px;">
								<el-input type="text" v-model="topForm.option_a" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項A（中文）"></el-input>
								<el-input type="text" v-model="topForm.option_a_en" clearable size="small" style="width: 85%;" placeholder="選項A（英文）"></el-input>
								<el-radio v-model="topForm.answer_o" label="a" style="margin-left: 10px;">正確答案</el-radio>
							</div>
						</el-form-item>

						<el-form-item label="選項B" prop="option_b">
							<div style="display: flex; align-items: center; margin-bottom: 10px;">
								<el-input type="text" v-model="topForm.option_b" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項B（中文）"></el-input>
								<el-input type="text" v-model="topForm.option_b_en" clearable size="small" style="width: 85%;" placeholder="選項B（英文）"></el-input>
								<el-radio v-model="topForm.answer_o" label="b" style="margin-left: 10px;">正確答案</el-radio>
							</div>
						</el-form-item>

						<el-form-item label="選項C" prop="option_c">
							<div style="display: flex; align-items: center; margin-bottom: 10px;">
								<el-input type="text" v-model="topForm.option_c" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項C（中文）"></el-input>
								<el-input type="text" v-model="topForm.option_c_en" clearable size="small" style="width: 85%;" placeholder="選項C（英文）"></el-input>
								<el-radio v-model="topForm.answer_o" label="c" style="margin-left: 10px;">正確答案</el-radio>
							</div>
						</el-form-item>

						<el-form-item label="選項D" prop="option_d">
							<div style="display: flex; align-items: center; margin-bottom: 10px;">
								<el-input type="text" v-model="topForm.option_d" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項D（中文）"></el-input>
								<el-input type="text" v-model="topForm.option_d_en" clearable size="small" style="width: 85%;" placeholder="選項D（英文）"></el-input>
								<el-radio v-model="topForm.answer_o" label="d" style="margin-left: 10px;">正確答案</el-radio>
							</div>
						</el-form-item>
					</div>
					<div v-else-if="topForm.topic_type == 2">
						<el-form-item>
							<el-button type="primary" @click="addAnswer">新增答案</el-button>
						</el-form-item>

						<el-form-item label="答案" prop="answer">
							<div v-for="(answer, index) in topForm.answer" :key="index" style="display: flex; align-items: center;">
								<el-input
									type="text"
									v-model="topForm.answer[index]"
									placeholder="輸入答案"
									clearable
									size="small"
									style="width: 85%; margin-right: 10px;">
								</el-input>
								<el-button
								type="danger"
								icon="el-icon-delete"
								size="small"
								:disabled="topForm.answer.length === 1"
								@click="removeAnswer(index)">
								删除
								</el-button>
							</div>
						</el-form-item>
					</div>
					
				</el-form>
			</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetTagForm">取 消</el-button>
					<el-button type="primary" @click="submitTag">確 定</el-button>
				</div>
			</el-dialog>
		</div>

		<div v-if="createModel == 2">
			<div class="mb-2 mt-2 pt-3">
				<template>
				<el-header style="float: left;">{{ com_info.com_no  }} - {{ com_info.title  }}</el-header>
				</template>
				<div style="float: right;">
				<el-button @click="resetForm">返 回</el-button>
				</div>
			</div>
			<div slot="footer" style="text-align: center; padding: 30px 0 30px 0">
			<el-form
				ref="form"
				:model="form"
				:label-width="layout.is_phone ? '80px' : '100px'"
			>
				<el-form-item prop="groupList">
					<el-table
						:data="groupList"
						border
						style="width: 100%"
						@selection-change="handleSelectionChange"
						:row-class-name="tableRowClassName" 
					>
						<el-table-column
						align="center"
						prop="name"
						label="組別名稱"
						></el-table-column>

						<el-table-column
						align="center"
						prop="total_score"
						label="試卷總分"
						></el-table-column>

						<el-table-column
						align="center"
						prop="participant_count"
						label="參賽人數"
						></el-table-column>


						<el-table-column
						align="center"
						prop="paper_count"
						label="比賽人數"
						></el-table-column>

						<el-table-column
						align="center"
						prop="average"
						label="平均分"
						></el-table-column>

						<el-table-column
						align="center"
						prop="median"
						label="中位數"
						></el-table-column>

						<el-table-column
						align="center"
						prop="check_count"
						label="未改試卷"
						to="data_correction"
						>
						<template slot-scope="scope">
							<router-link v-if="scope.row.check_count > 0"
							:to="{ name: 'data_correction', query: { com_id: scope.row.competition_id } }">
							<span  style="font-weight: 700;color: #ff0101;">
								{{ scope.row.check_count }}
							</span>
							</router-link>
							<span v-else>0</span>
						</template>
						</el-table-column>

						<el-table-column
						align="center"
						prop="time"
						label="時長限制"
						></el-table-column>

						<el-table-column
						align="center"
						label="榜單顯示人數"
						>
						<template slot-scope="v">
						<span>
							<el-tag type="warning">{{v.row.rank_num}}</el-tag>
						</span>
						</template>
						</el-table-column>

						<el-table-column prop="id" align="center" width="200" label="操作">
						<template slot-scope="scope">
							<el-button-group>
							<el-button
								size="mini"
								plain
								type="primary"
								@click="addRankingList(scope.row.id)"
								>查看</el-button>
							<el-button
								size="mini"
								plain
								type="warning"
								@click="checkCharts(scope.row.id)"
								>圖表</el-button>
								<el-button
								size="mini"
								plain
								type="success"
								@click="checkTopic(scope.row.id)"
								>試卷</el-button>
							</el-button-group>
						</template>
						</el-table-column>
					</el-table>
				</el-form-item>

			<div class="mb-2 mt-2 pt-3">
				
				<button-search
				:isphone="layout.is_phone"
				ref="buttonSearch"
				placeholder="搜索學生名稱"
				@search="searchEventTopic"
				:showGj="true"
				>
					<template #left>
					<!-- <el-button type="primary" style="margin-right: 20px;" v-if="com_info.start_status == 2" v-auth="'add'+auth_val" @click="queue" size="mini">快速排名</el-button> -->
					<el-tag  v-for="item in formQueue" :key="item.id" >{{item.level_name}}: {{item.num}}</el-tag>
				</template>
				<template #from>
					<el-form inline ref="form" :model="fromTopic" label-width="100px">
					<el-form-item label="學生名稱" class="mb-0">
						<el-input
						size="small"
						v-model="fromTopic.name"
						placeholder="搜索學生名稱"
						></el-input>
					</el-form-item>
					<el-form-item label="學生編號" class="mb-0">
						<el-input
						size="small"
						v-model="fromTopic.user_no"
						placeholder="搜索學生編號"
						></el-input>
					</el-form-item>

					<el-form-item label="學校名稱" class="mb-0">
						<el-input
						size="small"
						v-model="fromTopic.school_name"
						placeholder="搜索學校名稱"
						></el-input>
					</el-form-item>

					<el-form-item label="學生信箱" class="mb-0">
						<el-input
						size="small"
						v-model="fromTopic.email"
						placeholder="搜索學生信箱"
						></el-input>
					</el-form-item>


					<el-form-item class="mb-0">
						<el-button type="info" @click="searchEventTopic" size="small"
						>搜索
						</el-button>
						<el-button size="small" @click="clearSearchTopic"
						>清空篩選條件</el-button
						>
					</el-form-item>

					
					</el-form>
				</template>
				</button-search>
			</div>

			<!-- 表格 -->
			<div class="mt-3 pt-2">
				<el-table
				:data="userTopicList"
				border
				style="width: 100%"
				@selection-change="handleSelectionChange"
				>
				<el-table-column align="center" width="80" sortable prop="rank" label="排名">
				</el-table-column>
				
				<el-table-column align="center" prop="join_no" label="參加編號">
				</el-table-column>
						
				<el-table-column align="center" prop="topic_no"  width="200"  label="試卷編號">
					</el-table-column>
					
					<el-table-column align="center" prop="user_no" label="學生編號">
					</el-table-column>
					<el-table-column align="center" prop="name" label="學生名稱">
					</el-table-column>
					<el-table-column align="center" prop="school_name" label="學校名稱">
					</el-table-column>
					<el-table-column align="center" prop="email" label="學生信箱">
					</el-table-column>
					<el-table-column align="center" prop="score" label="成績">
					</el-table-column>
					<el-table-column align="center" prop="yes_num" label="答對數量">
					</el-table-column>
					<el-table-column align="center" prop="use_time_text" label="做題時長">
					</el-table-column>
					<el-table-column align="center" prop="end_time" label="交卷時間">
					</el-table-column>
					<el-table-column align="center" prop="level_id" label="名次">
					<template slot-scope="scope">
						<el-select 
						v-model="scope.row.level_id" 
						placeholder="請選擇" 
						@change="handleLevelChange(scope.row)"
						:disabled="true">
						<el-option
							v-if="!scope.row.is_none"
							:key="'absent'"
							label="缺席"
							:value="0">
						</el-option>
						<el-option
							v-else
							:key="'unselected'"
							label="未選擇"
							:value="0">
						</el-option>
						<el-option
							v-for="item in formQueue"
							:key="item.id"
							:label="item.level_name"
							:value="item.id">
						</el-option>
						</el-select>
					</template>
					</el-table-column>
				</el-table>
				<el-footer
					class="d-flex bg-white align-items-center px-0"
					style="float: right;"
				>
					<!-- 底部 -->

					<div style="flex: 1" class="px-2">
						<el-pagination
							:current-page="pageScore.current"
							:page-sizes="pageScore.sizes"
							:page-size="pageScore.size"
							@size-change="handleScoreSizeChange"
							@current-change="handleScoreCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pageScore.total"
						>
						</el-pagination>
					</div>
				</el-footer>
			</div>

			<el-dialog :close-on-click-modal="false"  title="題目" :visible.sync="checkTopicModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
					<template>
						<el-table :data="dialog_list"  max-height="550" border style="width: 100%"  :row-class-name="tableRowClassName">
							
							<el-table-column align="center" prop="topic_no" label="題目編號">
							</el-table-column>
							<el-table-column align="center" prop="title" label="題目">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
							</el-table-column>

							<el-table-column align="center"  prop="label_name"  label="標籤">
								<template slot-scope="v">
									<span>
										<el-tag type="warning">{{v.row.label_name}}</el-tag>
									</span>
								</template>
							</el-table-column>


							<el-table-column align="center"  prop="score" label="分數">
							</el-table-column>
							<el-table-column align="center"  prop="difficulty" label="難度">
							</el-table-column>

							<el-table-column align="center"  prop="total" label="答題人數">
							</el-table-column>

							<el-table-column align="center"  prop="correct" label="答對人數">
							</el-table-column>
							
							<el-table-column align="center"  prop="percentage" label="答對百分比">
							</el-table-column>
						</el-table>
					</template>
				</el-dialog>

			<el-dialog :close-on-click-modal="false"  title="圖表" :visible.sync="chartsModel" top="5vh" :width="layout.is_phone ? '90%' : '80%'" @open="initChart">
				<!-- 圖表内容 -->
				<div class="testbg">
					<el-row :gutter="layout.index_p.gutter" class=" h_l">
						<!-- 左边 -->
						<el-col :span="24" class="pb-4 h_100">
							<el-card class="box-card h_100 new_card" shadow="hover">
								<div slot="header" class="clearfix">
									<span>成績分佈</span>
								</div>
								<!-- 统计图容器 -->
								<div ref="myChart" style="width: 100%; height: 270px;"></div>
							</el-card>
						</el-col>
					</el-row>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="chartsModel = false">關 閉</el-button>
				</div>
			</el-dialog> 


				
			</el-form>

			<div slot="footer" style="text-align: center; padding: 30px 0 30px 0"></div>
		</div>
		</div>

		<div v-if="!createModel">
			<div class="mb-2 mt-2 pt-3">
				<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索登錄標題" @search="searchEvent" :showGj="true">
					<!-- 左边 -->
					<template #left>
						<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false,1)" type="primary" size="mini">添加比賽</el-button>
					</template>
					
					<!-- 高級搜索 -->
					<template #from>
						<el-form inline ref="form" :model="from" label-width="100px">

							<el-form-item label="比賽名稱" class="mb-0">
								<el-input size="small" v-model="from.title" placeholder="搜索比賽名稱"></el-input>
							</el-form-item>
							
							<el-form-item label="是否收費" class="mb-0">
								<el-select v-model="from.pay_type" size="small">
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="免費" :value="1"></el-option>
									<el-option label="收費" :value="2"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="報名狀態" class="mb-0">
								<el-select v-model="from.apply_status" size="small">
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="未開始" :value="0"></el-option>
									<el-option label="進行中" :value="1"></el-option>
									<el-option label="已結束" :value="2"></el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item label="比賽狀態" class="mb-0">
								<el-select v-model="from.start_status" size="small">
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="未開始" :value="0"></el-option>
									<el-option label="進行中" :value="1"></el-option>
									<el-option label="已結束" :value="2"></el-option>
									<el-option label="待公佈" :value="3"></el-option>
									<el-option label="已公佈" :value="4"></el-option>
									<el-option label="已關閉" :value="5"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="狀態" class="mb-0">
								<el-select v-model="from.status" size="small">
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="啟用" :value="1"></el-option>
									<el-option label="禁用" :value="0"></el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="創建時間"  size="small"  class="mb-0">
								<el-date-picker
									v-model="from.time"
									type="daterange"
									align="right"
									unlink-panels
									value-format="yyyy-MM-dd"
									range-separator="至"
									start-placeholder="開始日期"
									end-placeholder="結束日期"
									:picker-options="pickerOptions">
									</el-date-picker>
							</el-form-item>
							
							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
								<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
							</el-form-item>
					
						</el-form>
					</template>
				</button-search>
			</div>
			<!-- 查看内容的对话框 -->
			<el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" :width="layout.is_phone?'90%':'70%'" title="比賽簡介" @close="closeDialog">
						<!-- 使用 v-html 渲染 HTML 内容 -->
						<div v-html="dialogContent" class="dialog-content"></div>
						
						<span slot="footer" class="dialog-footer" >
							<el-button @click="closeDialogCom">關閉</el-button>
						</span>
					</el-dialog>
			<!-- 表格 -->
			<div class="mt-3 pt-2">
				<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column align="center" prop="com_no" label="編號" width="100">
					</el-table-column>

					<el-table-column align="center" prop="title" label="比賽名稱">
								<template slot-scope="scope">
									
										{{ scope.row.title }}
								</template>
					</el-table-column>

					<el-table-column align="center" prop="subject_name" label="學科名稱" width="100" >
					</el-table-column>
				
					<el-table-column align="center" width="80" prop="content" label="比賽簡介" >
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;"  class="name-wrapper"  @click="openDialog(scope.row.content)">
									<el-tag size="medium">查看</el-tag>
								</div>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="registration_count"  label="報名人數"  width="80">
						<template slot-scope="scope">
							<span :class="scope.row.registration_count> 0 ? 'text-success' : ''">{{ scope.row.registration_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="com_money"  label="報名金額" width="80">
						<template slot-scope="scope">
							<span :class="scope.row.com_money> 0 ? 'money_text' : ''">{{ scope.row.com_money }}</span>
						</template>
					</el-table-column>
				
					<el-table-column align="center" prop="prize_count"  label="訂單數" width="100">
						<template slot-scope="scope">
							<span :class="scope.row.prize_count> 0 ? 'text-success' : ''">{{ scope.row.prize_count }}</span>
							<span @click="openExl(scope.row.id, scope.row.title)" v-if="scope.row.prize_count> 0" style="margin-left: 5px;cursor: pointer;" >(<i style="color: #007bff;">導出</i>)</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prize_money" label="訂單金額" width="100">
						<template slot-scope="scope">
							<span :class="scope.row.prize_money> 0 ? 'money_text' : ''">{{ scope.row.prize_money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center"  label="優惠金額" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.diamonds_money > 0 " class="money_text">鑽：{{ scope.row.diamonds_money }} <br></span>
							<span v-if="scope.row.dis_money > 0 " class="money_text">券：{{ scope.row.dis_money }} <br></span>
							<span v-if="scope.row.gold_money > 0 " class="money_text">幣：{{ scope.row.gold_money }}</span>
							<span v-if="scope.row.diamonds_money == 0 && scope.row.dis_money == 0 && scope.row.gold_money == 0">0</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="order_money"  label="總金額" width="100">
						<template slot-scope="scope">
							<span :class="scope.row.order_money> 0 ? 'money_text' : ''">{{ scope.row.order_money }}</span>
						</template>
					</el-table-column>
					
					<el-table-column align="center" prop="submitted_count"  label="交卷人數" width="80">
						<template slot-scope="scope">
							<span :class="scope.row.submitted_count> 0 ? 'text-success' : ''">{{ scope.row.submitted_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="checked_count"  label="查看成績人數" width="80">
					</el-table-column>

					<el-table-column align="center" prop="pay_type" label="報名費@"  width="180">
							<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.pay_type==1">免費</span>
									<span v-if="v.row.pay_type==2"><i class="text-success" >學校用戶</i> : <span class="money_text">{{v.row.money}}</span> <br> <i class="text-primary" >非學校用戶</i> : <span class="money_text">{{v.row.no_school_money}}</span></span>
								</template>
						</el-table-column>	

					<el-table-column align="center" prop="school_name"  label="參加學校" width="100">
					</el-table-column>

					<el-table-column align="center" prop="com_status"  label="發佈比賽" width="100">
						<template slot-scope="scope">
							<span class="text-success" v-if="scope.row.com_status==0">待審核</span>
							<span class="text-primary" v-if="scope.row.com_status==1">已審核</span>
							<span class="text-danger" v-if="scope.row.com_status==2">已拒絕</span>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="apply_status"  label="報名狀態" width="100">
						<template slot-scope="scope">
							<span class="text-success" v-if="scope.row.apply_status==0">未開始</span>
							<span class="text-primary" v-if="scope.row.apply_status==1">進行中</span>
							<span class="text-danger" v-if="scope.row.apply_status==2">已結束</span>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="start_status"  label="比賽狀態" width="100">
						<template slot-scope="scope">
							<span class="text-success" v-if="scope.row.start_status==0">未開始</span>
							<span class="text-primary" v-if="scope.row.start_status==1">進行中</span>
							<span class="text-warning" v-if="scope.row.start_status==2">待公佈</span>
							<span class="text-warning" v-if="scope.row.start_status==3">待公佈</span>
							<span class="text-danger" v-if="scope.row.start_status==4">已公佈</span>
							<span class="text-secondary" v-if="scope.row.start_status==5">已關閉</span>
						</template>
					</el-table-column>

				
					<el-table-column align="center" prop="prize_end_status" label="訂購狀態" width="100">
							<template slot-scope="v">
									<span  class="text-success" v-if="v.row.prize_end_status==0">未開始</span>
									<span class="text-primary" v-if="v.row.prize_end_status==1">進行中</span>
									<span class="text-danger" v-if="v.row.prize_end_status==2">已結束</span>
								</template>
						</el-table-column>
					

					<el-table-column align="center" prop="status" label="狀態" width="100">
						<template slot-scope="scope">
							<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row)"
							plain>{{scope.row.status ? '啟用' : '禁用'}}
							</el-button>
						</template>
					</el-table-column>

					<el-table-column prop="id" align="center" width="280" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button v-if="scope.row.com_status == 2"  size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope,1)">操作</el-button>
								<el-button v-else size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope,0)">查看</el-button>
								
								
								<el-button size="mini" type="primary" plain v-auth="'edit'+auth_val" @click="openComModel(scope.row.id)">參賽</el-button>
								<!-- <el-button
                                    v-if="scope.row.com_status == 2"
                                    size="mini"
                                    plain
                                    type="success"
                                    v-auth="'edit' + auth_val"
                                    @click="submitStatus(scope.row.id, 0, '您確定要進行發佈？')"
                                >發佈</el-button> -->
								<el-button size="mini" plain type="warning" @click="openFenModel(scope.row)">分組</el-button>
								<el-button size="mini" plain type="success" @click="openSchool(scope.row)">學校排名</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div style="height: 60px;"></div>
			<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				<!-- 底部 -->
				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
					</el-pagination>
				</div>
			</el-footer>
		</div>





			 <!-- 弹框組件 分組 -->
			 <el-dialog
			:visible.sync="SchoolModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideSchoolModel"
			:title="FenTitle"
			 v-loading="layout.loading"
		>
			<div class="mt-3 pt-2" >
				<el-table :data="SchoolData" border style="width: 100%">
					<!-- 學校名稱 -->
					<el-table-column align="center" prop="school_name" label="學校名稱">
					</el-table-column>

					<el-table-column align="center" prop="com_count" label="報名人數">
						<template slot-scope="scope">
						<span :class="scope.row.com_count > 0 ? 'text-success' : ''">{{ scope.row.com_count || 0 }}</span>
						</template>
					</el-table-column>

					
					<!-- 交卷人數 -->
					<el-table-column align="center" prop="submit_count" label="交卷人數">
						<template slot-scope="scope">
						<span :class="scope.row.submit_count > 0 ? 'text-success' : ''">{{ scope.row.submit_count || 0 }}</span>
						</template>
					</el-table-column>

					<!-- 動態生成的列 -->
					<el-table-column
						v-for="(item, index) in dynamicColumns"
						:key="index"
						:label="item.level_name"
						align="center">
						<template slot-scope="scope">
							<span :class="scope.row[item.level_name] > 0 ? 'text-success' : ''">
								{{ scope.row[item.level_name] || 0 }}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<template #footer>
				<el-button @click="hideSchoolModel">關閉</el-button>
			</template>
		</el-dialog>

			 <!-- 弹框組件 分組 -->
		<el-dialog
			:visible.sync="FenModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideFenModel"
			:title="FenTitle"
			 v-loading="layout.loading"
		>
			<div class="mt-3 pt-2" >
				<el-table :data="tableFenData" border style="width: 100%" >
					<el-table-column align="center" prop="name" label="組別名稱">
					</el-table-column>
				
					<el-table-column align="center" prop="registration_count"  label="報名人數">
						<template slot-scope="scope">
							<span :class="scope.row.registration_count> 0 ? 'text-success' : ''">{{ scope.row.registration_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="com_money"  label="報名金額">
						<template slot-scope="scope">
							<span :class="scope.row.com_money> 0 ? 'money_text' : ''">{{ scope.row.com_money }}</span>
						</template>
					</el-table-column>
				
					<el-table-column align="center" prop="prize_count"  label="購買獎品人數">
						<template slot-scope="scope">
							<span :class="scope.row.prize_count> 0 ? 'text-success' : ''">{{ scope.row.prize_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prize_money" label="購買獎品金額">
						<template slot-scope="scope">
							<span :class="scope.row.prize_money> 0 ? 'money_text' : ''">{{ scope.row.prize_money }}</span>
						</template>
					</el-table-column>
					
					<el-table-column align="center" prop="order_count"  label="訂單數">
						<template slot-scope="scope">
							<span :class="scope.row.order_count> 0 ? 'text-success' : ''">{{ scope.row.order_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="order_money"  label="訂單金額">
						<template slot-scope="scope">
							<span :class="scope.row.order_money> 0 ? 'money_text' : ''">{{ scope.row.order_money }}</span>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="submitted_count"  label="交卷人數">
						<template slot-scope="scope">
							<span :class="scope.row.submitted_count> 0 ? 'text-success' : ''">{{ scope.row.submitted_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="checked_count"  label="查看成績人數">
					</el-table-column>

					<el-table-column prop="id" align="center" width="160" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" plain type="warning" @click="openPrizeModel(scope.row)">獎品分組查看</el-button>
							</el-button-group>
						</template>
					</el-table-column>

				</el-table>
			</div>

			<div class="mt-3 pt-2" v-if="tablePrizeData.length>0">
				<!-- 左边 -->
				<template>
					<div style="font-size: 20px;text-align: center;margin-bottom: 20px;">{{ prizeTitle }}</div>
				</template>
					
				<el-table :data="tablePrizeData" border style="width: 100%" >
					<el-table-column align="center" prop="prize_name" label="獎品名稱">
					</el-table-column>
				
					<el-table-column align="center" prop="rank_count"  label="獲獎人數">
						<template slot-scope="scope">
							<span :class="scope.row.rank_count> 0 ? 'text-success' : ''">{{ scope.row.rank_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="pay_count"  label="付款人數">
						<template slot-scope="scope">
							<span :class="scope.row.pay_count> 0 ? 'text-success' : ''">{{ scope.row.pay_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="pay_money"  label="付款金額">
						<template slot-scope="scope">
							<span :class="scope.row.pay_money> 0 ? 'money_text' : ''">{{ scope.row.pay_money }}</span>
						</template>
					</el-table-column>
				
					<el-table-column prop="id" align="center" width="160" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" plain type="warning" @click="openOrderModel(scope.row)">訂單查看</el-button>
							</el-button-group>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<template #footer>
				<el-button @click="hideFenModel">關閉</el-button>
			</template>
		</el-dialog>
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="題目">
			<p>{{ fullTitle }}</p>
		</el-dialog>

		 <!-- 弹框組件 訂單-->
		<el-dialog
			:visible.sync="orderModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideOrderModel"
			:title="'訂單列表 - ' + orderTitle"
		>
			
			<el-table :data="tableDataOrder" border style="width: 100%" >
				
				<el-table-column align="center" prop="order_no" label="訂單號">
				</el-table-column>
				
				<el-table-column align="center"  prop="name"  label="姓名">
				</el-table-column>

                <el-table-column align="center" prop="money"  label="付款金額">
						<template slot-scope="scope">
							<span class="money_text">{{ scope.row.money }}</span>
						</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="phone"  label="聯絡電話">
				</el-table-column>
				
				<el-table-column align="center"  prop="address"  label="學生地址">
				</el-table-column>


				<el-table-column align="center"  prop="school_name"  label="學校名稱">
				</el-table-column>
				
				<el-table-column align="center"  prop="school_phone"  label="學校聯絡電話">
				</el-table-column>
				
				<el-table-column align="center"  prop="local"  label="學校地址">
				</el-table-column>

                <el-table-column align="center" prop="status"  label="訂單狀態">
						<template slot-scope="scope">
							<span class="text-success" v-if="scope.row.status==1">已付款</span>
							<span class="text-primary" v-if="scope.row.status==3">處理中</span>
							<span class="text-danger" v-if="scope.row.status==4">已發貨</span>
						</template>
				</el-table-column>
				
			</el-table>
			<!-- 弹框的底部按钮 -->
			<template #footer>
				<el-button @click="hideOrderModel">關閉</el-button>
			</template>
		</el-dialog>
	


	</div>
	
	
</template>

<script>
	import XLSX from 'xlsx';
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import orderMode from '../../components/common/order-mode.vue';
	import buttonSearch from '@/components/common/button-search.vue';

import echarts from 'echarts'
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch,
			orderMode
		},
		
		inject: ['layout', 'app'],
		mixins: [common],
		data() { 
			return {
				dialogTitleVisible: false,
				fullTitle: '',

				FenModel:false,
				orderKey: 0,
				orderModel: false,
				tableFenData:[],
				tablePrizeData:[],
				orderInfo:{},
				FenTitle:'',
				orderTitle:'',
				
				colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
				editorOptions: {
					modules: {
						toolbar: [
							[{ header: [1, 2, false] }], // 標題选项
							['bold', 'italic', 'underline','image','indent','clean'], // 粗体、斜体、下划线
						
						]
					},
					placeholder: '請填写簡介'  // 设置占位符
				},
				createModel: false,
				editIndex: -1,

				createTagModel: false,
				editTagIndex: -1,

				createPaperModel: false,
				editPaperIndex: -1,
				
				createRankingModel: false,
				editRankingIndex: -1,

				createPrizeModel: false,
				editPrizeIndex: -1,
				tableDataOrder:[],
				//搜索數据
				from: {
					title: '',
					pay_type: -1,
					status: -1,
					apply_status: -1,
					start_status: -1,
					time: [],
				},
				auth_val: 'Shop',
				preUrl: "data/competitionList", //列表地址
				delAllUrl: "data/delCompetitionAll", //批量删除地址
				delUrl: "data/delCompetition", //删除單条地址
				addUrl: "data/addCompetition", //添加/修改地址
				addUrl: "data/addCompetition", //添加/修改地址
				editStatusUrl:"data/editStatusCompetition",//修改狀態地址
				
				tableData: [],
				form: {
						subject_id: null,
						title: "",
						title_vice: "",
						logo: "",
						img:"",
						title_vices: "",
						title_vice_img1: "",
						title_vice_img1_logo: "",
						title_vice_img2: "",
						title_vice_img2_logo: "",
						notice_end_time: "",
						check_rank_time: "",
						content: '',
						prize_info: '',
						message: '',
						school_id: [],
						pay_type: 1,
						money: 0,
						no_school_money: 0,
						is_school: 0,
						is_notapply: 0,
						is_absent_show: 0,
						is_show_time: 1,
						discount_code: '',
						discount_money: 0,
						postage: 0,
						time:[],
						com_time:null,
						result_date:null,
						end_time:null,
						paperList:[],//試卷數組
						ranking:[
							{level_name:'冠軍',sum:1,level:1,rank_show:1,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'亞軍',sum:1,level:1,rank_show:2,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'季軍',sum:1,level:1,rank_show:3,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'出席比賽',sum:1,level:4,rank_show:0,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
						],//名次獎品數組
				},
				rules: {
					school_id: [
						{
							validator: (rule, value, callback) => {
								if (this.form.is_school === 3 && (!value || value.length === 0)) {
									callback(new Error("參加學校不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					title: [{
						required: true,
						trigger: 'blur', // 触发方式是失去焦點
						validator: (rule, value, callback) => {
							// 如果值为空，则返回错误
							if (!value) {
							callback(new Error("比賽名稱不能為空"));
							return;
							}

							// 计算中文和英文字符的長度
							const chineseCount = value.replace(/[^\u4e00-\u9fa5]/g, "").length; // 计算中文字符數
							const englishCount = value.replace(/[\u4e00-\u9fa5]/g, "").length; // 计算英文字符數

							// 判断中文字符是否超過限制
							if (chineseCount > 35) {
							callback(new Error("中文字符不能超過35个"));
							return;
							}

							// 判断英文字符是否超過限制
							if (englishCount > 70) {
							callback(new Error("英文字符不能超過70个"));
							return;
							}

							// 如果都没问題，验证通过
							callback();
						}
					}
					],
					content: [{
							required: true,
							message: "比賽簡介不能為空",
							trigger: 'blur',
						},
					],
					time: [{
							required: true,
							message: "請選擇報名時間",
							trigger: 'change',
						},
					],
					com_time: [{
							required: true,
							message: "請選擇比賽日期",
							trigger: 'change',
						},
					],
					result_date: [{
							required: true,
							message: "請選擇比賽公布日期",
							trigger: 'change',
						},
					],
					end_time: [{
							required: true,
							message: "請選擇獎品訂購截止日期",
							trigger: 'change',
						},
					],
					notice_end_time: [{
							required: true,
							message: "請選擇公告展示截止日期",
							trigger: 'change',
						},
					],
					check_rank_time: [{
							required: true,
							message: "請選擇查看成績截止日期",
							trigger: 'change',
						},
					],
					paperList: [{
							required: true,
							message: "請添加比賽試卷",
							trigger: 'blur',
						},
					],
					ranking: [{
							required: true,
							message: "請添加名次獎品",
							trigger: 'blur',
						},
					],
					user_label_ids: [
						{
							validator: (rule, value, callback) => {
								if (this.form.is_school === 4 && (!value || value.length === 0)) {
									callback(new Error("用戶標籤不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
				},
				
				order_list:[],
				scoreId: 0,
				chartsModel: false,
				dialog_list: [],
				checkTopicModel: false,
				com_info:[],
      			rankList:[],
				groupList: [],//比賽科目列表
				userTopicList: [],//參加科目學生列表
				pageScore: {
					current: 1,
					sizes: [50, 100, 200],
					size: 200,
					total: 0
				},
				//搜索數据（參賽詳情高級搜索）
				fromTopic: {
					name: "",//學生名稱
					user_no: "",//學生編號
					school_name: "",//學校名稱
					email: "",//學生信箱
				},
				previewSrc: '',


				label_ids:null,
				user_label_options: [],
				topForm:{
					title: '',
					title_en: '',
					answer:[''],
					answer_o:'a',
					difficulty:1,
					icon: "",
					img:"",
					label_id: null,
					label_name: '',
					topic_type: 1,
					option_a: '',
					option_a_en: '',
					option_b: '',
					option_b_en: '',
					option_c: '',
					option_c_en: '',
					option_d: '',
					option_d_en: '',
					score: 10,
					status: 0,
					use_time: 0,
					sel_time: 0,
					option_sel:"",
					upload:[],
					max_len:100,
				},
				rulesTag: {
					title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
					answer: [
						{ 
							required: true, 
							validator: (rule, value, callback) => {
								// 检查 answer 數組中的每一个元素是否为空
								if (value.some(answer => !answer)) {
									callback(new Error("答案不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					option_a: [{
							required: true,
							message: "选项A不能為空",
							trigger: 'blur',
						},
					],
					option_b: [{
							required: true,
							message: "选项B不能為空",
							trigger: 'blur',
						},
					],
					option_c: [{
							required: true,
							message: "选项C不能為空",
							trigger: 'blur',
						},
					],
					option_d: [{
							required: true,
							message: "选项D不能為空",
							trigger: 'blur',
						},
					],
					label_id: [{
							required: true,
							message: "請選擇標籤",
							trigger: 'blur',
						},
					],
					score: [{
						required: true,
						message: "分數不能為空",
						trigger: 'blur',
					}, {
						validator: (rule, value, callback) => {
							if (!Number.isInteger(Number(value)) || value === '' || value <= 0) {
								callback(new Error('分數必須是大於0的整數'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}],
				},

				formRanking:{
					level_name:'',
					prize:[],
					sum:1,
					level:4,
					rank_show:0,
					diamond:0,
					money:0,
					postage:0,
					gift_id:''
				},
				rulesRanking: {
					level_name: [{
							required: true,
							message: "名次不能為空",
							trigger: 'blur',
						},
					],
				},
				
				formPrize:{
					name:'',
					money:0,
					postage:0,
					content:'',
				},
				rulesPrize: {
					name: [{
							required: true,
							message: "獎品名稱不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "獎品備註不能為空",
							trigger: 'blur',
						},
					],
					
					// money: [{
					// 	required: true,
					// 	message: "金額不能為空",
					// 	trigger: 'blur',
					// }, {
					// 	validator: (rule, value, callback) => {
					// 		if (!Number.isInteger(Number(value)) || value === '' || value <= 0) {
					// 			callback(new Error('金額必須是大於0的整數'));
					// 		} else {
					// 			callback();
					// 		}
					// 	},
					// 	trigger: 'blur'
					// }
					// ],
					// postage: [{
					// 	required: true,
					// 	message: "郵費不能為空",
					// 	trigger: 'blur',
					// }, {
					// 	validator: (rule, value, callback) => {
					// 		if (!Number.isInteger(Number(value)) || value === '') {
					// 			callback(new Error('必須是大於0的整數'));
					// 		} else {
					// 			callback();
					// 		}
					// 	},
					// 	trigger: 'blur'
					// }
					// ],
				},
				formPaper: {
					name: '',
					time: '',
					timeArr: null,
					latest_time: '',
					total_score:0,
					count:0,
					topList:[],//題目數組
					grade_id:[]//年級數組
				},
				submitLoading:false,
				rulesPaper: {
					name: [{
							required: true,
							message: "組別名稱不能為空",
							trigger: 'blur',
						},
					],
					timeArr: [
						{
						required: true,
						message: '請選擇比賽時間',
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							// 確保 value 是一个數組，并且有两个時間
							if (value && value.length === 2) {
							const [startTime, endTime] = value;
							// 如果開始時間 >= 結束時間，提示错误
							if (new Date(startTime).getTime() >= new Date(endTime).getTime()) {
								callback(new Error('比賽開始時間必須小於結束時間'));
							} else {
								callback();
							}
							} else {
							// 如果未选或格式不对，这里也可以放一个错误提示
							callback(new Error('請選擇比賽時間'));
							}
						},
						trigger: 'change', // 或 'blur'，视需求而定
						},
					],
					latest_time: [{
							required: true,
							message: "請選擇比賽最遲入場時間",
							trigger: 'blur',
						},
					],
					
					time: [{
							required: true,
							message: "做題時長不能為空",
							trigger: 'blur',
						}, {
							validator: this.validateTime, // 自定义验证规则
							trigger: 'blur'
						}
					],
					topList: [{
							required: true,
							message: "請添加題目",
							trigger: 'blur',
						},
					],
					grade_id: [{
							required: true,
							message: "請選擇对应年級",
							trigger: 'blur',
						},
					],
				},
				user_gift: [],//禮物列表
				active: 0, //步骤數
				inputVisible: false,
        		inputValue: '',
				label_list: [],//標籤類型
				all_label_list: [],//標籤類型

				subject_list: [],
				school_list:[],
				grade_list:[],
				rule_list: [],
				check_img_list:[],
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容
				prizeTitle: '' ,         // 存储當前对话框的内容

				SchoolModel:false,
				SchoolData:[],

				openModelType: '', //打開彈出框的類型，0查看，1編輯
				dateLimits: {
					disabledDate: (time) => false, // 初始不限制
				},
				
				latestTimePickerOptions: {}, // 最遲入場時間的动态限制
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		
		created() {
			this.commonList(['school_list','topic_subject_label','user_gift']);
			this.fetchUserLabels();
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			'form.is_notapply'(newVal) {
				if (Number(newVal) === 1) {
					this.form.pay_type = 1;
				}
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
			dynamicColumns() {
				return this.SchoolData.length > 0 ? this.SchoolData[0].rank : [];
			},
			processedGradeList() {
				// 創建一个新數組，確保不直接修改原始數据
				return this.grade_list.map(grade => {
					// 检查 this.form.paperList 中任一 paper 的 grade_id 數組是否包含當前 grade 的 id
					const isDisabled = this.form.paperList.some(paper => paper.grade_id.includes(Number(grade.id)));
					// 返回新的对象，并可能添加 disabled 属性
					return {
						...grade,
						disabled: isDisabled
					};
				});
			}
		},
		methods: {
			checkCharts(com_info_id) {
				this.layout.loading = true;
				this.axios.post(
					"/admin/data/scoreCheckList",
					{ com_info_id: com_info_id },
					{ token: true }
				)
				.then((res) => {
					this.order_list = res.data.data.list;
					this.chartsModel = true;  // 设置 chartsModel 为 true，触发弹窗顯示
					this.layout.loading = false;
				})
				.catch((err) => {
					// 處理错误
					this.layout.loading = false;
					this.createQueueModel = false;
				});
			},
			// 打开模态框
			checkTopic(e) {
			this.layout.loading = true;
					this.axios.post('/admin/data/getTopicList', {
						id: e,
					}, {
						token: true,
					}).then(res => {
						let all = res.data.data
			this.dialog_list = all.list;

			// 打开dialog
			this.checkTopicModel = true
						this.layout.loading = false;
					}).catch(err => {
						// 失敗
						this.layout.loading = false;
					})
			},
			handleScoreSizeChange(val) {
				this.pageScore.size = val
				this.addRankingList()
			},
			handleScoreCurrentChange(val) {
				this.pageScore.current = val
				this.addRankingList()
			},
			searchEventTopic(e = false) {
				// 簡單搜索
				if (typeof e === 'string') {
					this.search = e;
					this.getUserTopicList()
					return
				}
				this.search = this.fromTopic
				this.getUserTopicList()
			},
			tableRowClassName({ row }) {
				// 判断行的 ID 是否与选中的 ID 相等，返回不同的類名
				return row.id === this.selectedRowId ? 'selected-row' : '';
			},
			openExl(com_id, competitionTitle) {
				this.layout.loading = true;
				this.axios.post('/admin/data/orderInfoExlList', { com_id: com_id }, {
					token: true,
				}).then(res => {
					// const baseUrl = 'https://api.yifangmeng.com/';
					const baseUrl = 'https://api.lets-go.fun/';
					const filePath = res.data.data;
					const fileUrl = `${baseUrl}${filePath}`;
					const link = document.createElement('a');
					link.href = fileUrl;
					// 下載文件名使用比賽名稱，替換非法字元
					const safeName = (competitionTitle || '訂單明細').replace(/[/\\:*?"<>|]/g, '_').trim() || '訂單明細';
					link.download = safeName + '.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link); // 移除鏈接節點
					this.layout.loading = false;  // 隐藏加载状态
				}).catch(err => {
					// 失败处理
					this.layout.loading = false;
					console.error(err);
				});
			},
			openSchool(row){
				this.layout.loading = true;
				this.FenTitle = row.com_no + ' - ' + row.title
				this.axios.post('/admin/data/ComSchoolRank', {id:row.id}, {
                        token: true,
                    }).then(res => {
						let all = res.data
						let list = all.data.list || []
						// 确保每个学校都有 submit_count 字段
						list = list.map(item => {
							return {
								...item,
								com_count: item.com_count || 0,
								submit_count: item.submit_count || 0,
								paper_count: item.paper_count || 0
							}
						})
                        this.SchoolModel = true
						this.SchoolData = list
						console.log(this.SchoolData )
						this.layout.loading = false;
                    }).catch(err => {
                        // 失敗
						this.SchoolModel = true
						this.SchoolData = []
                        this.layout.loading = false;
                    })
                    
			},
			hideSchoolModel(){
				this.SchoolModel = false
				this.SchoolData = []
			},
			 // 清空篩選條件
			 clearSearchTopic() {
				this.fromTopic = {
					name: "",//學生名稱
					user_no: "",//
					school_name: "",//學校名稱
					email: "",//學生信箱
				};

				this.search = "";
				this.pageScore.current = 1;
				this.getUserTopicList();
			},
			openFenModel(row){
				this.layout.loading = true;
				this.FenTitle = row.com_no + ' - ' + row.title
				this.axios.post('/admin/data/competitionGroupList', {
					com_id: row.id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
				
					this.tableFenData = list
					this.tablePrizeData  = []
					this.FenModel = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handlePreview(imgUrl) {
				if(imgUrl.img_type){
					this.previewSrc = imgUrl.icon;
				}else{
					this.previewSrc = imgUrl.img;
				}
				
				this.$nextTick(() => {
				// 触发 el-image 内部的 preview 功能
				this.$refs.previewImage.showViewer = true;
				});
			},
			initChart() {
				this.$nextTick(() => {
					this.drawLine();
				});
			},
			drawLine() {
				if (!this.$refs.myChart) {
					console.error("myChart reference is undefined");
					return;
				}
				
				// 初始化 ECharts 实例
				let myChart = echarts.init(this.$refs.myChart);

				// 配置图表參數
				myChart.setOption({
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['人數']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						// boundaryGap: false,
						data: this.order_list?.score || []  // 如果 score 數据缺失，使用空數組
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							name: '人數',
							type: 'bar',
							color: '#ffda4a',
							data: this.order_list?.count || []  // 如果 count 數据缺失，使用空數組
						}
					]
				});
			},
			// 處理比賽時間范围变化
			handleTimeRangeChange(val) {
				if (val && val.length === 2) {
					const [startTime, endTime] = val;

					// 动态设置 "最遲入場時間" 的日期范围
					this.latestTimePickerOptions = {
					disabledDate(time) {
						const currentDate = time.setHours(0, 0, 0, 0); // 将時間部分归零，仅比较日期
						const startDate = new Date(startTime).setHours(0, 0, 0, 0);
						const endDate = new Date(endTime).setHours(0, 0, 0, 0);

						// 限制日期范围：不在范围内的日期禁用
						return currentDate < startDate || currentDate > endDate;
					},
					};
				} else {
					// 清空最遲入場時間限制
					this.latestTimePickerOptions = {};
				}
			},

			// 验证最遲入場時間是否在范围内
			validateLatestTime(val) {
				if (!this.formPaper.timeArr || this.formPaper.timeArr.length !== 2) {
					this.$message.error('請先選擇比賽時間範圍');
					this.formPaper.latest_time = ''; // 清空最遲入場時間
					return;
				}

				const [startTime, endTime] = this.formPaper.timeArr;
				const selectedTime = new Date(val).getTime();
				const start = new Date(startTime).getTime();
				const end = new Date(endTime).getTime();

				if (selectedTime < start || selectedTime > end) {
					this.$message.error('最遲入場時間必須在比賽時間範圍內，請重新選擇');
					this.formPaper.latest_time = ''; // 清空不合法的選擇
				}
			},
			updateDateLimits(dates) {
				if (dates && dates.length === 2) {
					const endDate = new Date(dates[1]).getTime(); // 報名結束日期
					this.dateLimits = {
						disabledDate: (time) => {
							return time.getTime() < endDate;
						},
					};
				} else {
					this.dateLimits = {
						disabledDate: (time) => false, // 无限制
					};
				}
			},
			scrollToTop() {
				// 獲取滾動容器並設置滾動條位置
				const content = this.$refs.dialogContent;
				if (content) {
					content.scrollTop = 0; // 將滾動條設置到頂端
				}
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialog(content) {
				this.dialogContent = content; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialogCom() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
			},
			openPrizeModel(row){
				this.prizeTitle = '獎品購買情況 - ' + row.name
				this.layout.loading = true;
				this.axios.post('/admin/data/competitionPrizeList', {
					com_id: row.competition_id,
					com_info_id: row.id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.tablePrizeData = list
					this.FenModel = true
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			startCountdown() {
				this.countdown = 60; // 初始化倒计时
				this.timer = setInterval(() => {
					if (this.countdown > 0) {
					this.countdown--;
					} else {
					this.handleTimeout();
					}
				}, 1000);
			},
			handleTimeout() {
				clearInterval(this.timer);
				if (!this.paymentStatus) {
					this.paymentStatus = 'failure'; // 倒计时结束默認失敗
				}
			},
			handleWebSocketNotification(status) {
				// WebSocket 收到支付狀態通知
				clearInterval(this.timer);
				if (status === 'success') {
					this.paymentStatus = 'success';
				} else if (status === 'failure') {
					this.paymentStatus = 'failure';
				}
			},
			retryPayment() {
				this.paymentStatus = '';
				this.startCountdown();
				// 触发重新支付逻辑
			},
			closeDialog() {
				this.pyaOrderDialog = false;
				clearInterval(this.timer);
			},
			 //提交成績
			 submitStatus(id, actionType, message) {
                this.$confirm(message, '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    // 用戶確認提交
                    let post = {id:id,
                        actionType:actionType // 可根據 actionType 判斷通過或拒絕的處理
                        }
                    this.layout.loading = true;
                    this.axios.post('/admin/data/CompublishStatus', post, {
                        token: true,
                    }).then(res => {
                        this.getList();
                        this.layout.loading = false;
                        
                    }).catch(err => {
                        // 失敗
                        this.layout.loading = false;
                    })
                    
                })
                .catch(() => {
                    // 用戶取消提交
                    console.log('取消');
                });
            },
			
			hideFenModel() {
				this.FenModel = false
			},
			openOrderModel(row){
				this.orderKey = row.id
				this.orderInfo = row
				this.orderTitle = row.prize_name

				this.layout.loading = true;
				this.axios
					.post(
					"/admin/data/OrderPrizeList",
					{
					search:row,
					},
					{
					token: true,
					}
					)
					.then((res) => {
						let all = res.data.data.list
						this.tableDataOrder = all
						this.layout.loading = false;
						this.orderModel = true
					})
					.catch((err) => {
					// 失敗
					
					this.layout.loading = false;
				});
			},
			hideOrderModel() {
				this.orderModel = false
			},
			validateTitle() {
				// 这部分是直接在輸入框失去焦點时触发验证的逻辑
				this.$refs.form.validateField('title');
			},
			delPrize(scope){
				// 獲取要刪除的獎品 ID 或索引
				const index = scope.$index; // 行的索引
				this.formRanking.prize.splice(index, 1); // 刪除對應行
			},
			delRanking(scope){
				// 獲取要刪除的名次 ID 或索引
				const index = scope.$index; // 行的索引
				this.form.ranking.splice(index, 1); // 刪除對應行
			},
			delDomain(scope){
				// 獲取要刪除的試卷 ID 或索引
				const index = scope.$index; // 行的索引
				this.form.paperList.splice(index, 1); // 刪除對應行
			},
			deleteTagAll(){
				this.formPaper.topList = []
			},
			deleteTag(scope) {
				// 獲取要刪除的題目 ID 或索引
				const index = scope.$index; // 行的索引
				this.formPaper.topList.splice(index, 1); // 刪除對應行
			},
			downloadTemplate() {
				// 文件的 URL (可以是相對路徑或完整URL)
				// const baseUrl = 'https://api.yifangmeng.com';
				const baseUrl = 'https://api.lets-go.fun';
				const filePath = '/excel/題目模版文件.xlsx';
				const fileUrl = `${baseUrl}${filePath}`;
				const link = document.createElement('a');
				link.href = fileUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link); // 移除鏈接節點
			},
			cinstTime(){
				// 获取當前日期
				const currentDate = new Date();
				const year = currentDate.getFullYear();
				const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以+1
				const day = String(currentDate.getDate()).padStart(2, '0');

				// 生成完整的日期字符串格式，如 '2024-11-03'
				const formattedDate = `${year}-${month}-${day}`;

				// 使用默認時間并将日期和時間拼接起来
				return ['08:00:00', '09:00:00'].map(time => `${formattedDate} ${time}`);
			},
			 // 自定义時間验证规则
			 validateTime(rule, value, callback) {
				if (this.formPaper.timeArr.length === 2) {
					const startTime = this.convertTimeToMinutes(this.formPaper.timeArr[0]);
					const endTime = this.convertTimeToMinutes(this.formPaper.timeArr[1]);
					const selectedTime = parseInt(value);
					console.log(startTime)
					if (isNaN(selectedTime)) {
						callback(new Error('請輸入有效的做題時長'));
					} else if (selectedTime > (endTime - startTime)) {
						callback(new Error('做題時長不能超過比賽時間范围'));
					} else {
						callback();
					}
				} else {
					callback(new Error('請選擇比賽時間范围'));
				}
			},
			// 辅助方法：将時間转为分钟數
			convertTimeToMinutes(time) {
				const [hours, minutes, seconds] = time.split(':').map(Number);
				return hours * 60 + minutes + seconds / 60;
			},
			changeGift() {
				
			},
			changeType() {
				// 清空當前的 label_list
				this.label_list = [];

				// 移除可能的重复项，假设每个標籤有唯一的 id
				this.label_list = this.all_label_list[this.form.subject_id];

				if (this.label_list.length > 0) {
					// 如果 label_list 不为空，则设置默認选中项为第一个元素的 ID
					this.label_ids = this.label_list[0].id;
				} else {
					// 如果 label_list 为空，可以设置 label_id 为 null 或进行其他逻辑處理
					this.label_ids = null;
				}
			},
			next() {
				if (this.active++ > 2) this.active = 0;
			},
			createModelbut(){
				this.createModel = false
				this.active = 0
			},
			createPaperModelbut(){
				this.createPaperModel = false
				
			},
			// 添加一个新的答案輸入框
			addAnswer() {
				console.log(this.topForm.answer)
				this.topForm.answer.push(''); // 每次點擊新增按钮，往數組中添加一个空字符串
			},
			// 删除对应的答案輸入框
			removeAnswer(index) {
				this.topForm.answer.splice(index, 1); // 删除指定索引的答案
			},
			addTag(e = false){
				// 增加
				if (!e) {
					const defaultLabelId = (this.label_list && this.label_list.length > 0) ? this.label_list[0].id : null;
					this.topForm.label_id = (this.label_ids !== null && this.label_ids !== undefined) ? this.label_ids : defaultLabelId;
					if (this.topForm.label_id !== null && this.topForm.label_id !== undefined) {
						this.topForm.label_id = Number(this.topForm.label_id);
					}
					this.$set(this.topForm, 'answer', ['']);
					// 初始化表單
					this.editTagIndex = -1
				} else {
					// 修改
					this.topForm = {
						title:e.row.title,
						title_en: e.row.title_en || '',
						answer: e.row.topic_type == 2 ? (typeof e.row.answer === 'string' ? e.row.answer.split(",") : e.row.answer) : [''],
						icon: e.row.img && e.row.img.includes('https') ? e.row.img : e.row.icon,
						img:e.row.img,
						answer_o:e.row.answer_o,
						difficulty:e.row.difficulty,
						
						label_id:e.row.label_id,
						label_name:e.row.label_name,
						topic_type: e.row.topic_type,
						option_a:e.row.option_a,
						option_a_en: e.row.option_a_en || '',
						option_b:e.row.option_b,
						option_b_en: e.row.option_b_en || '',
						option_c:e.row.option_c,
						option_c_en: e.row.option_c_en || '',
						option_d:e.row.option_d,
						option_d_en: e.row.option_d_en || '',
						selectedLabel:e.row.selectedLabel,
						score:e.row.score,
						status: 0,
						use_time: 0,
						sel_time: 0,
						option_sel:"",
						upload:[],
						max_len:100,
							
					}
					this.editTagIndex = e.$index
				}
				this.createTagModel = true
			},
			
			handleTagClose(tag) {
				this.topicTags.splice(this.topicTags.indexOf(tag), 1);
			},

			//导入exle
			beforeUpload(file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: 'array'});
					
					// 假设你的數据在第一个 sheet 中
					const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
					
					// 解析 Excel 數据，header: 1 会返回二维數組形式的數据
					// const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 2 });
					const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
						header: 2,
						raw: false // ✅ 保留原样字符串（关键）
					});
					// 去除第一行（表头）
					// jsonData.shift();

					// 将解析後的數据處理成需要的格式
					this.handleExcelData(jsonData);
				};
				reader.readAsArrayBuffer(file);

				// 阻止默認的上傳行为
				return false;
			},
			handleExcelData(jsonData) {
				// 首先检查所有數据的科目類型是否一致
				const isSubjectValid = jsonData.every(row => Number(row.subject) === this.form.subject_id);
				if (!isSubjectValid) {
					// 如果科目類型不一致，提示错误信息
					this.$message.error('科目類型不正確'); // 使用消息提示
					return; // 取消上傳，结束方法
				}

				  // 檢查是否有重複的題目
				const duplicateTitle = jsonData.find(row => 
					this.formPaper.topList.some(item => item.title === row.title)
				);

				if (duplicateTitle) {
					this.$message.warning(`題目 "${duplicateTitle.title}" 已經存在，請確認後再上傳`);
					return; // 停止處理，退出方法
				}

				// 如果科目類型正確，继续處理數据
				jsonData.forEach(row => {
					const label = this.label_list.find(label => label.label_id === Number(row.label_id)); // 根据 label_id 查找標籤
					const labelName = label ? label.name : ''; // 获取標籤名稱，如果找不到则为空
					const labelId = label ? label.id : 1; // 获取標籤名稱，如果找不到则为空
					const topForm = {
						title: row.title || '',            // 从 Excel 的數據中讀取標題
						title_en: row.title_en || '',      // 英文題目
						answer: row.topic_type == 2 
					? (typeof row.answer === 'string' 
						? (row.answer.includes(',') ? row.answer.split(',') : [row.answer]) 
						: row.answer) 
					: [''],
						answer_o: row.answer_o || 'a',     // 选项答案
						difficulty: row.difficulty || 1,    // 難度
						img: row.img || '',                // 圖片
						label_id: labelId,      // 標籤 ID
						label_name: labelName,              // 从 label_list 获取標籤名稱
						topic_type: row.topic_type || 1,    // 題目類型
						option_a: row.hasOwnProperty('option_a') ? row.option_a : '', // 选项 A
						option_a_en: row.option_a_en || '', // 选项 A（英文）
						option_b: row.hasOwnProperty('option_b') ? row.option_b : '', // 选项 B
						option_b_en: row.option_b_en || '', // 选项 B（英文）
						option_c: row.hasOwnProperty('option_c') ? row.option_c : '', // 选项 C
						option_c_en: row.option_c_en || '', // 选项 C（英文）
						option_d: row.hasOwnProperty('option_d') ? row.option_d : '', // 选项 D
						option_d_en: row.option_d_en || '', // 选项 D（英文）
						score: row.score || 10,            // 分數
						status: row.status || 0,           // 狀態
						use_time: row.use_time || 0,       // 使用時間
						sel_time: row.sel_time || 0,       // 選擇時間
						option_sel: row.option_sel || '',   // 選擇的选项
						upload: row.upload || [],           // 上傳文件信息
						subject: row.subject || 1,          // 科目
						max_len: row.max_len || 100         // 最大長度
					};


					// 将數据 push 到 formPaper.topList 中
					this.formPaper.topList.push(topForm);

					// 计算數量和分數總和
					this.formPaper.total_score = this.formPaper.topList.reduce((sum, item) => sum + Number(item.score), 0);
					this.formPaper.count = this.formPaper.topList.length;
				});
			},


			//添加題目
			submitTag() {
				this.$refs.topForm.validate(valid => {
					if (valid) {
						// 验证英文题目和选项的一致性：要么全部都有，要么都为空
						if (this.topForm.topic_type == 1) {
							const hasTitleEn = this.topForm.title_en && this.topForm.title_en.trim() !== '';
							const hasOptionAEn = this.topForm.option_a_en && this.topForm.option_a_en.trim() !== '';
							const hasOptionBEn = this.topForm.option_b_en && this.topForm.option_b_en.trim() !== '';
							const hasOptionCEn = this.topForm.option_c_en && this.topForm.option_c_en.trim() !== '';
							const hasOptionDEn = this.topForm.option_d_en && this.topForm.option_d_en.trim() !== '';
							const filledCount = [hasTitleEn, hasOptionAEn, hasOptionBEn, hasOptionCEn, hasOptionDEn].filter(Boolean).length;
							
							// 如果有部分有值（不是0也不是5），则不符合要求
							if (filledCount > 0 && filledCount < 5) {
								this.$message.error('英文標題和所有選項的英文必須同時填寫或同時為空，不能部分填寫');
								return;
							}
						}
						
						this.handleLabelChange(this.topForm.label_id)
						this.topForm.img_type = 1;
						if (this.editTagIndex === -1) {
							// 添加新題目
							this.formPaper.topList.push(this.topForm);
						} else {
							// 修改现有題目
							this.$set(this.formPaper.topList, this.editTagIndex, {...this.topForm});
						}
						
						 // 计算數量和分數總和
						this.formPaper.total_score = this.formPaper.topList.reduce((sum, item) => sum + Number(item.score), 0);

						this.formPaper.count = this.formPaper.topList.length;
						// 重置表單和關閉模态框
						this.resetTagForm();
					}
				});
			},
			resetTagForm() {
				this.topForm = {
					title: '',
					title_en: '',
					answer:[''],
					answer_o:'a',
					difficulty:1,
					icon: "",
					img:"",
					label_id: this.label_ids,
					label_name: '',
					topic_type: 1,
					option_a: '',
					option_a_en: '',
					option_b: '',
					option_b_en: '',
					option_c: '',
					option_c_en: '',
					option_d: '',
					option_d_en: '',
					score: 10,
					status: 0,
					use_time: 0,
					sel_time: 0,
					option_sel:"",
					upload:[],
					max_len:100,
				};
				this.createTagModel = false;
				this.editTagIndex = -1; // 重置 editTagIndex
			},

			//添加修改獎品
			addPrize(e = false){
				if (!e) {
					// 初始化表單
					this.editPrizeIndex = -1
				} else {
					// 修改
					this.formPrize = {
						name: e.row.name,
						money: e.row.money,
						postage: e.row.postage,
						content: e.row.content,
					}
					this.editPrizeIndex = e.$index
				}
				// 打开dialog
				this.createPrizeModel = true
			},
			submitPrize() {
				this.$refs.formPrize.validate(valid => {
					if (valid) {
						if (this.editPrizeIndex === -1) {
							// 添加新題目
							this.formRanking.prize.push(this.formPrize);
						} else {
							// 修改现有題目
							this.$set(this.formRanking.prize, this.editPrizeIndex, {...this.formPrize});
						}
						
						// 重置表單和關閉模态框
						this.resetPrizeForm();
					}
				});
			},
			resetPrizeForm() {
				this.formPrize = {
					name:'',
					money:0,
					postage:0,
					content:'',
				};
				
				this.createPrizeModel = false;
				this.editPrizeIndex = -1; // 重置 editTagIndex
			},
			
			//添加修改名次
			addRanking(e = false){
				if (!e) {
					// 初始化表單
					this.editRankingIndex = -1
				} else {
					// 修改
					this.formRanking = {
						is_default: e.row.is_default || 0,
						id: e.row.id,
						level_name: e.row.level_name,
						prize: e.row.prize,
						level:e.row.level,
						rank_show:e.row.rank_show,
						sum: e.row.sum,
						diamond: e.row.diamond,
						postage: e.row.postage,
						money: e.row.money,
						gift_id: e.row.gift_id,
					}
					this.editRankingIndex = e.$index
				}
			
				// 打开dialog
				this.createRankingModel = true
			},

			addRankingList(e){
				if(e){
					this.scoreId = e;
					this.selectedRowId = e;
				}
				this.layout.loading = true;
				this.axios
					.post(
					"/admin/data/getUserTopicList",
					{
						id: this.scoreId,
						page: this.pageScore.current,
						limit: this.pageScore.size,
					},
					{
						token: true,
					}
					)
					.then((res) => {
						let all = res.data.data.list
						this.pageScore.total = all.total
						this.userTopicList = all.list
						this.formQueue = all.rank
						this.layout.loading = false;
					})
					.catch((err) => {
					// 失敗
					this.layout.loading = false;
				});
			},
			getUserTopicList(){
				this.layout.loading = true;
				this.axios
					.post(
					"/admin/data/getUserTopicList",
					{
					id: this.scoreId,
					search: this.search,
					page: this.pageScore.current,
					limit: this.pageScore.size,
					},
					{
					token: true,
					}
					)
					.then((res) => {
						let all = res.data.data.list
						this.pageScore.total = all.total
						this.userTopicList = all.list
						this.formQueue = all.rank
						this.layout.loading = false;
					})
					.catch((err) => {
					// 失敗
					this.$message.error(err);
					this.layout.loading = false;
				});
			},
			
			submitRanking() {
				
				this.$refs.formRanking.validate(valid => {
					if (valid) {
						if (this.editRankingIndex === -1) {
							
							// 添加新題目
							this.form.ranking.push(this.formRanking);
						
						} else {
							// 修改现有題目
							this.$set(this.form.ranking, this.editRankingIndex, {...this.formRanking});
						}
						
						// 重置表單和關閉模态框
						this.resetRankingForm();
					}
				});
			},
			resetRankingForm() {
				this.formRanking = {
					level_name:'',
					prize:[],
					sum:1,
					level:4,
					rank_show:0,
					diamond:0,
					money:0,
					postage:0,
					gift_id:''
				};
				
				this.createRankingModel = false;
				this.editRankingIndex = -1; // 重置 editTagIndex
			},

			//添加試卷
			submitPaper() {
				this.$refs.formPaper.validate(valid => {
					if (valid) {
						if (this.editPaperIndex === -1) {
							// 添加新題目
							this.form.paperList.push(this.formPaper);
						} else {
							// 修改现有題目
							this.$set(this.form.paperList, this.editPaperIndex, {...this.formPaper});
						}

						// 重置表單和關閉模态框
						this.resetPaperForm();
					}
				});
			},
			
			resetPaperForm() {
				this.formPaper = {
					name: '',
					timeArr: null,
					latest_time: '',
					time:60,
					total_score:0,
					count:0,
					topList:[],//題目數組
					grade_id:[]//年級數組
				};
				
				this.createPaperModel = false;
				this.editPaperIndex = -1; // 重置 editTagIndex
			},
			addDomain(e = false){
				this.changeType()
				if (!e) {
					// 初始化表單
					this.editPaperIndex = -1
				} else {
					// 修改
					this.formPaper = {
						id: e.row.id,
						name: e.row.name,
						time: e.row.time,
						timeArr: e.row.timeArr,
						latest_time:e.row.latest_time,
						total_score: e.row.total_score,
						count:e.row.count,
						topList:e.row.topList,
						grade_id:e.row.grade_id.map(id => Number(id)),
					}
					this.editPaperIndex = e.$index
				}
				// 打开dialog
				this.createPaperModel = true
			},
			
			handleLabelChange(value) {
				if (this.label_list.length > 0) {
					const selectedItem = this.label_list.find(item => item.id === value);
					this.topForm.label_name = selectedItem.name; // 获取和存储 name
				}
			},
		
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.submitLoading = true;
						this.form.id = this.editIndex
						this.form.is_ins = 1
						this.addOrEdit(this.form)
						// 關閉模态框
						// this.resetForm()
					}
				})
				
			},
			resetForm() {
				this.form = {
					subject_id: null,
					 title: "",
					 content: '',
					 message: '',
					 prize_info: '',
					 logo: '',
					 subject_id: this.form.subject_id,
					 school_id: [],
					 pay_type: 1,
					 is_school: 0,
					 is_notapply: 0,
					 is_absent_show: 0,
					 is_show_time: 1,
					 money: 0,
					 no_school_money: 0,
					 discount_code:'',
					 discount_money:0,
					 postage:0,
					 time:[],
					 com_time:null,
					 result_date:null,
					 end_time:null,
					 notice_end_time: null,
					 check_rank_time: null,
					 paperList:[],//試卷數組
					 ranking:[
						 {level_name:'冠軍',sum:1,level:1,rank_show:1,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
						 {level_name:'亞軍',sum:1,level:1,rank_show:2,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
						 {level_name:'季軍',sum:1,level:1,rank_show:3,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
						 {level_name:'出席比賽',sum:1,level:4,rank_show:0,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
					 ],//名次獎品數組
				};

				this.createModel = false;
				this.getList();
				this.editIndex = -1; // 重置 editTagIndex
			},

			//參賽數據
			openComModel(e){
				this.layout.loading = true;
				this.axios
					.post(
					"/admin/data/getGroupList",
					{
						id: e,
					},
					{
						token: true,
					}
					)
					.then((res) => {
					
					this.groupList = res.data.data.list.list,
					this.com_info = res.data.data.list.com_info
					this.editIndex = e;
					this.pageScore.total = []
					this.userTopicList = []
					this.formQueue = []
					// 打开dialog
					this.createModel = 2;
					this.layout.loading = false;
					})
					.catch((err) => {
					// 失敗
					this.layout.loading = false;
					});
				
			},




			// 打开模态框
			openModel(e = false,type) {
				this.openModelType = type;
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						subject_id: this.form.subject_id,
						title: "",
						title_vice: "",
						title_vices: "",
						title_vice_img1: "",
						title_vice_img1_logo: "",
						title_vice_img2: "",
						title_vice_img2_logo: "",
						logo: "",
						img:"",
						content: '',
						prize_info: '',
						message: '',
						school_id: [],
						pay_type: 1,
						is_school: 0,
						is_notapply: 0,
						is_absent_show: 0,
						is_show_time: 1,
						money: 0,
						no_school_money: 0,
						discount_code:'',
						discount_money:0,
						postage:0,
						time:[],
						com_time:null,
						result_date:null,
						end_time:null,
						notice_end_time: null,
						check_rank_time: null,
						paperList:[],//試卷數組
						level_name:'',
						
						ranking:[
							{level_name:'冠軍',sum:1,level:1,rank_show:1,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'亞軍',sum:1,level:1,rank_show:2,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'季軍',sum:1,level:1,rank_show:3,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
							{level_name:'出席比賽',sum:1,level:4,rank_show:0,diamond:0,money:0,is_default:1,prize:[],gift_id:''},
						],//名次獎品數組
						user_label_ids: [],
					}
					this.updateDateLimits(false)
					this.editIndex = -1
				} else {
					
					// 修改
					this.form = {
						id:e.row.id,
						subject_id: e.row.subject_id,
						title: e.row.title,
						title_vices:e.row.title_vices,
						title_vice:e.row.title_vice,
						title_vice_img1:e.row.title_vice_img1 || "",
						title_vice_img1_logo:e.row.title_vice_img1 || "",
						title_vice_img2:e.row.title_vice_img2 || "",
						title_vice_img2_logo:e.row.title_vice_img2 || "",
						logo:e.row.logo,
						img:"",
						content: e.row.content,
						prize_info: e.row.prize_info,
						message: e.row.message,
						school_id:e.row.school_id.map(id => Number(id)),
						pay_type:e.row.pay_type,
						money:e.row.money,
						no_school_money:e.row.no_school_money,
						discount_code:e.row.discount_code,
						discount_money:e.row.discount_money,
						postage:e.row.postage,
						is_school:e.row.is_school,
						is_notapply: e.row.is_notapply !== undefined ? Number(e.row.is_notapply) : 0,
						is_absent_show: e.row.is_absent_show !== undefined ? Number(e.row.is_absent_show) : 0,
						is_show_time: e.row.is_show_time !== undefined ? Number(e.row.is_show_time) : 1,
						paperList:e.row.paperList,
						ranking:e.row.ranking,
						com_time:e.row.com_time,
						result_date:e.row.result_date,
						notice_end_time:e.row.notice_end_time,
						check_rank_time:e.row.check_rank_time,
						end_time:e.row.end_time,
						time:e.row.time,
						user_label_ids: (e.row.label_id && typeof e.row.label_id === 'string') ? e.row.label_id.split(',').filter(Boolean).map(Number) : [],
					}
					this.updateDateLimits(e.row.time)
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = 1
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.school_list = list.school
					this.grade_list = list.grade
					this.subject_list = list.subject
					this.all_label_list = list.label
					this.user_gift = list.user_gift
					
					if (this.subject_list.length > 0) {
						
						// 设置默認选中项为subject_list中的第一个元素
						this.form.subject_id = this.subject_list[0].id
						this.label_list = list.label[this.subject_list[0].id]
						if (this.label_list.length > 0) {
							// 设置默認选中项为subject_list中的第一个元素
							this.label_ids = this.label_list[0].id;
						}
					}
					this.layout.loading = false;
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},


			handleAvatarSuccessLogo(res, file) {
				this.form.logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.img = res.encryption.data.list.url
				}
			},
			handleAvatarSuccessTitleViceImg1(res, file) {
				this.form.title_vice_img1_logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.title_vice_img1 = res.encryption.data.list.url
				}
			},
			handleAvatarSuccessTitleViceImg2(res, file) {
				this.form.title_vice_img2_logo = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.title_vice_img2 = res.encryption.data.list.url
				}
			},
			
			handleAvatarSuccess(res, file) {
				this.topForm.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.topForm.img = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
			
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳圖片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			handleClose(done) {
				this.active = 0
				done();
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					pay_type: -1,
					status: -1,
					apply_status: -1,
					start_status: -1,
					time: [],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇圖片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			},
			fetchUserLabels() {
				this.axios
					.post(
						"/admin/data/userLabelList",
						{
							page: 1,
							limit: 1000,
							search: {},
						},
						{ token: true }
					)
					.then((res) => {
						const rows = res.data?.data?.list?.list || [];
						this.user_label_options = rows.map((r) => ({ id: Number(r.id), name: r.name }));
					})
					.catch(() => {});
			},
		}
	}
</script>

<style>
	.ql-toolbar {
		display: flex;
		flex-wrap: wrap;  /* 確保工具栏中的元素能够自动换行 */
		align-items: center;  /* 对齐工具栏内的按钮 */
		justify-content: flex-start;
	}
	.ql-snow .ql-picker-label::before{
		position: absolute;
	}
	.ql-toolbar .ql-formats {
		margin-right: 10px;  /* 调整工具栏按钮之間的間距 */
	}
	.ql-snow .ql-picker svg {
		position: absolute;
    top: 1px;
}
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .dialog-content img {
  max-width: 100%; /* 限制圖片宽度不超過容器 */
  height: auto;    /* 保持圖片纵横比 */
}
.dialog-content {
  max-height: 300px; /* 限制内容的最大高度，防止内容太長撑出 */
  overflow-y: auto;  /* 内容超出时滚动 */
}
.radio-group-card {
  display: inline-block; /* 保持內聯塊，避免換行 */
  padding: 5px 10px;
}

.radio-row {
  display: flex; /* 將內容設為橫向排列 */
  gap: 10px; /* 添加選項之間的間距 */
}

.no-wrap {
  white-space: nowrap; /* 強制內容不換行 */
}

.custom-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  display: inline-block;

 
}
.custom-box .el-radio{
	margin-bottom: 0px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.selected-row {
  background-color: #f0f9ff !important; /* 选中行的背景颜色 */
}
</style>